import API_BASE_URL from "./config";

const getDomainDetails = async () => {
    try {

        const response = await fetch(
            `${API_BASE_URL}/social-links`,
            {
                method: "GET",

                credentials: "include",

                headers: {
                    Accept: "application/json",
                },
            }
        );

        const data = await response.json();

        if (!response.ok) {

            throw new Error(
                data.message ||
                "Unable to fetch domain details."
            );

        }

        return data;

    } catch (error) {

        console.error(
            "Domain Details API Error:",
            error
        );

        throw error;

    }
};

export default getDomainDetails;